import { useTranslation } from 'react-i18next';
import { useAmazonConnectContacts } from '@/hooks/useAmazonConnectContacts';
import { hasActiveCallLeg } from '@/components/amazon-connect/contactUtils';
import { useAppSelector } from '@/store/hooks';
import { Box, Typography } from '@gapartners/ui';

export function IntentBanner() {
  const { t } = useTranslation();
  const { activeContacts } = useAmazonConnectContacts();
  const { contactId, intentName } = useAppSelector(state => state.call);
  const hasActiveContact =
    Boolean(contactId) || activeContacts.some(hasActiveCallLeg);
  const displayedIntent = intentName?.trim()
    ? intentName
    : t('components.contactCenter.unknownIntent');
  if (!hasActiveContact) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        py: 1.5,
        px: 3,
        bgcolor: '#EFF6FF',
        borderBottom: '1px solid',
        borderColor: '#BFDBFE',
        flexShrink: 0,
        minHeight: 49,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Typography variant="subtitle2" fontWeight={700} color="#111827">
          {`${t('components.contactCenter.detectedIntent')}: ${displayedIntent}`}
        </Typography>
      </Box>
    </Box>
  );
}
